var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-container",
            { staticClass: "grey lighten-4", attrs: { fluid: "", "pa-0": "" } },
            [
              _c(
                "v-row",
                { staticStyle: {}, attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "align-self-center",
                      attrs: { md: "auto", xs: "auto", sm: "auto" }
                    },
                    [
                      _c("crud-button", {
                        attrs: {
                          "x-large": "",
                          color: "blue-grey darken-1",
                          icon: "fa-chevron-left",
                          tooltip: _vm.$t("global.crud.buttons.return")
                        },
                        on: {
                          clicked: function($event) {
                            return _vm.back()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass:
                        "flex-grow-1 flex-shrink-0 container-data-filter-info",
                      attrs: { cols: "1" }
                    },
                    [
                      _c(
                        "v-container",
                        { attrs: { fluid: "", "pa-0": "" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c("v-col", { attrs: { sm: "12", cols: "12" } }, [
                                _c("div", { staticClass: "form-field-name" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "productsTypesOperations.productType"
                                        )
                                      ) +
                                      " "
                                  )
                                ]),
                                _c("div", { staticClass: "form-field-value" }, [
                                  _vm._v(" " + _vm._s(_vm.productType) + " ")
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("div", { attrs: { id: "controlsContainer" } }, [
            _c(
              "div",
              {
                staticClass:
                  "card-title table-controls px-3 d-flex align-center justify-space-between"
              },
              [
                _c(
                  "div",
                  [
                    _c("crud-button", {
                      attrs: {
                        "x-large": "",
                        color: "light-blue lighten-2",
                        icon: "fa-plus",
                        tooltip: _vm.$t("global.crud.button.add")
                      },
                      on: {
                        clicked: function($event) {
                          return _vm.create()
                        }
                      }
                    })
                  ],
                  1
                ),
                _c("div"),
                _c(
                  "div",
                  [
                    _c("crud-button", {
                      attrs: {
                        large: "",
                        color: "blue",
                        icon: "fa-sync-alt",
                        tooltip: _vm.$t("global.crud.buttons.refreshTable")
                      },
                      on: {
                        clicked: function($event) {
                          return _vm.refreshItemsView()
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            )
          ]),
          _c(
            "div",
            { attrs: { id: "dataContainer" } },
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.items,
                  options: _vm.options,
                  page: _vm.pagination.page,
                  "server-items-length": _vm.pagination.totalItems,
                  "no-results-text": _vm.$t(
                    "global.datatable.noMatchingResults"
                  ),
                  "no-data-text": _vm.$t("global.datatable.noDataAvailable"),
                  "footer-props": {
                    "items-per-page-options": _vm.rowsPerPageItems,
                    "show-first-last-page": true,
                    "show-current-page": true
                  },
                  loading: _vm.loading,
                  light: "",
                  "multi-sort": "",
                  dense: ""
                },
                on: {
                  "update:options": function($event) {
                    _vm.options = $event
                  },
                  "update:page": function($event) {
                    return _vm.$set(_vm.pagination, "page", $event)
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "body",
                    fn: function({ items }) {
                      return [
                        _c(
                          "tbody",
                          _vm._l(items, function(item) {
                            return _c("tr", { key: item.code }, [
                              _c(
                                "td",
                                [
                                  _c("crud-button", {
                                    attrs: {
                                      "x-small": "",
                                      color: "orange",
                                      icon: "fa-pen",
                                      tooltip: _vm.$t(
                                        "global.crud.buttons.edit"
                                      )
                                    },
                                    on: {
                                      clicked: function($event) {
                                        return _vm.edit(item.code)
                                      }
                                    }
                                  }),
                                  item.deletionDate === undefined ||
                                  item.deletionDate === null
                                    ? _c("crud-button", {
                                        attrs: {
                                          "x-small": "",
                                          color: "red",
                                          icon: "fa-trash",
                                          tooltip: _vm.$t(
                                            "global.crud.buttons.delete"
                                          )
                                        },
                                        on: {
                                          clicked: function($event) {
                                            return _vm.suspend(item.code)
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "td",
                                [
                                  item.agency !== undefined &&
                                  item.agency !== null
                                    ? _c(
                                        "v-tooltip",
                                        {
                                          attrs: { right: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function({ on }) {
                                                  return [
                                                    _c("span", _vm._g({}, on), [
                                                      _vm._v(
                                                        _vm._s(item.agency.code)
                                                      )
                                                    ])
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(item.agency.name))
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c("td", [_vm._v(_vm._s(item.volumeFrom))]),
                              _c("td", [_vm._v(_vm._s(item.volumeTo))]),
                              _c("td", [_vm._v(_vm._s(item.weightFrom))]),
                              _c("td", [_vm._v(_vm._s(item.weightTo))]),
                              _c("td", [_vm._v(_vm._s(item.time))])
                            ])
                          }),
                          0
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "600",
            persistent: "",
            "no-click-animation": ""
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c("validation-observer", {
            ref: "obs",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ invalid, validated, passes }) {
                  return [
                    _c(
                      "v-card",
                      [
                        _c(
                          "v-toolbar",
                          {
                            attrs: {
                              dark: "",
                              color: "primary",
                              dense: "",
                              flat: ""
                            }
                          },
                          [
                            _c(
                              "v-toolbar-title",
                              { staticClass: "white--text" },
                              [_vm._v(" " + _vm._s(_vm.formTitle) + " ")]
                            ),
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: { icon: "" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.close()
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("fas fa-times")])],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-card-text",
                          { staticClass: "details-list" },
                          [
                            _c(
                              "v-form",
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm12" },
                                      [
                                        !_vm.editMode
                                          ? _c("validation-provider", {
                                              attrs: {
                                                name: _vm.$t(
                                                  "productsTypesOperations.agency"
                                                ),
                                                rules: "required"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function({ errors }) {
                                                      return [
                                                        _c("v-autocomplete", {
                                                          attrs: {
                                                            items:
                                                              _vm.agenciesItems,
                                                            loading:
                                                              _vm.agencies
                                                                .isLoading,
                                                            "search-input":
                                                              _vm.agencies
                                                                .search,
                                                            "hide-no-data": "",
                                                            "no-data-text": _vm.$t(
                                                              "global.autocomplete.noDataFound"
                                                            ),
                                                            "item-text":
                                                              "description",
                                                            "item-value":
                                                              "code",
                                                            label: _vm.$t(
                                                              "productsTypesOperations.agency"
                                                            ),
                                                            placeholder: _vm.$t(
                                                              "global.autocomplete.starTypingToSearch"
                                                            ),
                                                            "error-messages": errors,
                                                            clearable: ""
                                                          },
                                                          on: {
                                                            "update:searchInput": function(
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.agencies,
                                                                "search",
                                                                $event
                                                              )
                                                            },
                                                            "update:search-input": function(
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.agencies,
                                                                "search",
                                                                $event
                                                              )
                                                            },
                                                            focus: function(
                                                              $event
                                                            ) {
                                                              _vm.agencies.isEdit = true
                                                            },
                                                            change: function(
                                                              $event
                                                            ) {
                                                              _vm.agencies.isEdit = false
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.item
                                                                .agencyCode,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.item,
                                                                "agencyCode",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.agencyCode"
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          : _c("v-text-field", {
                                              attrs: {
                                                label: _vm.$t(
                                                  "productsTypesOperations.agency"
                                                ),
                                                disabled: ""
                                              },
                                              model: {
                                                value: _vm.item.agencyString,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "agencyString",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.agencyString"
                                              }
                                            })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm6" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t(
                                              "productsTypesOperations.volumeFrom"
                                            ),
                                            rules: "decimal:5,4"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "productsTypesOperations.volumeFrom"
                                                        ),
                                                        type: "decimal",
                                                        "error-messages": errors
                                                      },
                                                      on: {
                                                        keypress: function(
                                                          $event
                                                        ) {
                                                          return _vm.decimalOnlyField(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.item.volumeFrom,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.item,
                                                            "volumeFrom",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.volumeFrom"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm6" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t(
                                              "productsTypesOperations.volumeTo"
                                            ),
                                            rules: "decimal:7,4"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "productsTypesOperations.volumeTo"
                                                        ),
                                                        type: "decimal",
                                                        "error-messages": errors
                                                      },
                                                      on: {
                                                        keypress: function(
                                                          $event
                                                        ) {
                                                          return _vm.decimalOnlyField(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.item.volumeTo,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.item,
                                                            "volumeTo",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.volumeTo"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm6" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t(
                                              "productsTypesOperations.weightFrom"
                                            ),
                                            rules: "decimal:5,4"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "productsTypesOperations.weightFrom"
                                                        ),
                                                        type: "decimal",
                                                        "error-messages": errors
                                                      },
                                                      on: {
                                                        keypress: function(
                                                          $event
                                                        ) {
                                                          return _vm.decimalOnlyField(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.item.weightFrom,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.item,
                                                            "weightFrom",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.weightFrom"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm6" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t(
                                              "productsTypesOperations.weightTo"
                                            ),
                                            rules: "decimal:7,4"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "productsTypesOperations.weightTo"
                                                        ),
                                                        type: "decimal",
                                                        "error-messages": errors
                                                      },
                                                      on: {
                                                        keypress: function(
                                                          $event
                                                        ) {
                                                          return _vm.decimalOnlyField(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.item.weightTo,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.item,
                                                            "weightTo",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.weightTo"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm12" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t(
                                              "productsTypesOperations.time"
                                            ),
                                            rules: "required|max:30"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "productsTypesOperations.time"
                                                        ),
                                                        required: "",
                                                        "error-messages": errors,
                                                        counter: "30"
                                                      },
                                                      on: {
                                                        keypress: function(
                                                          $event
                                                        ) {
                                                          return _vm.integerOnlyField(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value: _vm.item.time,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.item,
                                                            "time",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "item.time"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-card-actions",
                          [
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "black", text: "" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.close()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("global.buttons.close")) +
                                    " "
                                )
                              ]
                            ),
                            _vm.editMode
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "orange", text: "" },
                                    on: {
                                      click: function($event) {
                                        return passes(_vm.update)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("global.buttons.update")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              : _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "green", text: "" },
                                    on: {
                                      click: function($event) {
                                        return passes(_vm.save)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("global.buttons.create")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }